var twig = require("twig").twig,
    tokens = [{"type":"raw","value":"<input (input) type=\"text\">"}],
    template = twig({"id":"$resolved:0a62d9ae50077a2acc509013d2a281c6f56556a76006cc0d0bec61216903364ba6d4aaa0bf187a764c83b195a6f5a0f683ef025fb2ec4a71b6e8a72753234b3c:magic-input-integer.twig","data":[{"type":"raw","value":"<input (input) type=\"text\">"}],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;